import { Component, Output, EventEmitter } from '@angular/core';
import { TranslocoService, TranslocoPipe } from '@jsverse/transloco';
import { MatDialogRef, MatDialog } from '@angular/material/dialog';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { RegisterService } from 'app/services/register.service';
import { DialogUtilsService } from 'app/modules/utils/dialog-utility.service';
@Component({
  selector: 'app-user_privacy-step',
  templateUrl: './user_privacy-step.component.html',
  styleUrls: ['./user_privacy-step.component.scss'],
  imports: [
    TranslocoPipe,
  ],
})
export class UserPrivacyStepComponent {
  @Output() back = new EventEmitter<void>();
  privacyContent: SafeHtml = '';
  constructor(
    private _dialogRef: MatDialogRef<UserPrivacyStepComponent>,
    private sanitizer: DomSanitizer,
    private registerService: RegisterService,
    private dialogUtilsService: DialogUtilsService
  ) {}
  
    ngOnInit(): void {
      const cachedPrivacy = localStorage.getItem('ferrer_user_privacy');
      const cachedTimestamp = localStorage.getItem('ferrer_terms_timestamp');
  
      const now = new Date().getTime();
      const expirationTime = 24 * 60 * 60 * 1000;
  
      if (cachedPrivacy && cachedTimestamp && now - parseInt(cachedTimestamp, 10) < expirationTime) {
        this.privacyContent = cachedPrivacy;
      } else {
        this.registerService.getUserPrivacy().subscribe((privacyContent) => {
          this.privacyContent = this.sanitizer.bypassSecurityTrustHtml(privacyContent);
          localStorage.setItem('ferrer_user_privacy', privacyContent);
          localStorage.setItem('ferrer_terms_timestamp', now.toString());
        });
      }
    }

  goBack() {
    this.back.emit();
  }

  shouldShowCloseButton(): boolean {
    const apiVersion = JSON.parse(localStorage.getItem('ferrerSessionData'));
    return this.dialogUtilsService.shouldShowCloseButton();
  }
}